var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('top-bar'),_c('div',{attrs:{"id":"main-container-home"}},[_c('app-main'),(!_vm.$isPhone)?_c('footer-bar'):_vm._e()],1),(_vm.$isPhone)?_c('footer-bar-m'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }